import React from 'react';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    Legend,
    Tooltip,
    CartesianGrid,
    ReferenceLine,
    XAxis,
    YAxis,
} from 'recharts';

import Tick from 'components/charts/Tick';
import TooltipContent from './otaInsightsTooltip';

const OTAInsightsLineChart = ({
    data,
    demand,
    lines,
    dataKey,
    refLineValue = null,
    xAxisTickFormatter = null,
    yAxisTickFormatter = null,
}) => {
    const legendStyle = {
        fontSize: 14,
        textAlign: 'center',
    };

    const formatTick = (formatter, value) => (formatter ? formatter(value) : value);
    const renderXTick = (axisProps) => (
        <Tick {...axisProps} formatter={(value) => formatTick(xAxisTickFormatter, value)} />
    );
    const renderYTick = (axisProps) => (
        <Tick {...axisProps} formatter={(value) => formatTick(yAxisTickFormatter, value)} />
    );

    return (
        <ResponsiveContainer height={400}>
            <LineChart data={data} stackOffset="sign" barSize={40}>
                {lines.map((line) => (
                    <Line
                        key={line.name}
                        dataKey={line.dataKey}
                        name={line.name}
                        stroke={line.color}
                        strokeWidth={2}
                        dot={{
                            stroke: line.color,
                            strokeWidth: 2,
                            fill: line.color,
                        }}
                    />
                ))}
                {refLineValue ? <ReferenceLine x={refLineValue} stroke="red" strokeWidth={2} /> : null}
                <XAxis dataKey={dataKey} tick={renderXTick} height={35} tickMargin={10} />
                <YAxis width={45} tickLine={false} tick={renderYTick} />
                <Legend align="right" iconType="circle" iconSize={12} wrapperStyle={legendStyle} />
                <Tooltip isAnimationActive={false} content={<TooltipContent demand={demand} />} filterNull={false} />
                <CartesianGrid strokeDasharray="2 2" />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default OTAInsightsLineChart;
